import { render } from "./Phonebots.vue?vue&type=template&id=e941b13a&scoped=true"
import script from "./Phonebots.vue?vue&type=script&lang=js"
export * from "./Phonebots.vue?vue&type=script&lang=js"

import "./Phonebots.vue?vue&type=style&index=0&id=e941b13a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\fchristo\\Documents\\adam-aibackend\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e941b13a"]])

export default __exports__